// @flow

import React, { type Node } from 'react';
import { getSafeBoletoUrl, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { useIsMobile } from '@tectonics/hooks';

export function SaveToPdfButton(): Node {
  const isMobile = useIsMobile();
  const incomingPayment = usePendingIncomingPayment();
  return (
    <a
      style={{...SavePdfButtonStyle, width: isMobile ? '100%' : 'calc(50% - 16px)'}}
      target="blank"
      href={getSafeBoletoUrl(incomingPayment) + '&format=pdf'}
    >SALVAR EM PDF
    </a>
  );
}

const SavePdfButtonStyle = {
  background: '#ffffff',
  color: '#2397d4',
  fontSize: '14px',
  fontWeight: '700',
  borderRadius: '5px',
  margin: '10px 5px',
  padding: '10px 0',
  border: '2px solid #2397d4',
  textDecoration: 'none',
  textAlign: 'center',
};
